import { fetchFinance } from "utils/api";

export const queryList = async (params) => {
  return await fetchFinance("/sales/activity", {
    type: "referrer",
    ...params,
  });
};

export const exportCsv = async (params) => {
  return await fetchFinance("/sales/activity", {
    type: "referrer",
    output: "csv",
    ...params,
  });
};

export const querySales = async (params) => {
  return await fetchFinance("/action", {
    action: "getSales",
    ...params,
  });
};

export const queryReferrer = async (params) => {
  return await fetchFinance("/action", {
    action: "getReferrer",
    ...params,
  });
};
